import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import axios from 'axios';
import { API } from '../App';

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  const [settings, setSettings] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    fetchData();
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const fetchData = async () => {
    try {
      const [socialRes, settingsRes] = await Promise.all([
        axios.get(`${API}/social-media`),
        axios.get(`${API}/settings`)
      ]);
      setSocialLinks(socialRes.data.filter(link => link.visible));
      setSettings(settingsRes.data);
    } catch (error) {
      console.error('Error fetching footer data:', error);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content container">
        <div className="footer-section">
          <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '0.5rem' : '0.75rem', marginBottom: isMobile ? '0.75rem' : '1rem' }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_academy-admin-2/artifacts/aa7nbreh_adhva-logo.png" 
              alt="Adhva Academy" 
              style={{ height: isMobile ? '32px' : '40px', width: 'auto' }}
            />
            <div>
              <h3 style={{ margin: 0, fontSize: isMobile ? 'clamp(1rem, 3vw, 1.125rem)' : '1.25rem', color: 'var(--primary)' }}>Adhva Academy</h3>
              <p style={{ margin: 0, fontSize: isMobile ? 'clamp(0.65rem, 2vw, 0.7rem)' : '0.75rem', color: 'var(--accent)', fontWeight: 600 }}>The Learning Path</p>
            </div>
          </div>
          <p style={{ fontSize: isMobile ? 'clamp(0.8rem, 2vw, 0.9rem)' : '1rem', lineHeight: isMobile ? '1.4' : '1.6' }}>Empowering UPSC aspirants with quality education and mentorship.</p>
          {socialLinks.length > 0 && (
            <div className="social-links">
              {socialLinks.map(link => (
                <a key={link.id} href={link.url} target="_blank" rel="noopener noreferrer" className="social-icon" style={{ background: link.color }}>
                  <i className={link.icon}></i>
                </a>
              ))}
            </div>
          )}
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/ncert-mastery">NCERT Mastery</Link>
          <Link to="/mentorship">Mentorship</Link>
          <Link to="/about-us">About Us</Link>
        </div>

        <div className="footer-section">
          <h3>Resources</h3>
          <Link to="/resources">Study Materials</Link>
          <Link to="/blog">Super Insight</Link>
          <Link to="/videos">Video Library</Link>
          <Link to="/current-affairs">Current Affairs</Link>
        </div>

        <div className="footer-section">
          <h3>Contact Us</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <a
              href="mailto:adhvaacademy@gmail.com"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: 'inherit', textDecoration: 'none', fontSize: isMobile ? 'clamp(0.8rem, 2vw, 0.9rem)' : '1rem' }}
            >
              <Mail size={isMobile ? 16 : 18} style={{ flexShrink: 0 }} aria-label="email" />
              <span>adhvaacademy@gmail.com</span>
            </a>
            <a
              href="https://wa.me/918867198007"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: 'inherit', textDecoration: 'none', fontSize: isMobile ? 'clamp(0.8rem, 2vw, 0.9rem)' : '1rem' }}
            >
              {/* WhatsApp logo (inline SVG) */}
              <svg xmlns="http://www.w3.org/2000/svg" width={isMobile ? "16" : "18"} height={isMobile ? "16" : "18"} viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
                <path d="M20.52 3.48A11.91 11.91 0 0 0 12.06 0C5.5 0 .18 5.33.18 11.91c0 2.1.55 4.17 1.6 6l-1.7 6 6.18-1.62a12 12 0 0 0 5.8 1.49h.01c6.57 0 11.9-5.33 11.9-11.9 0-3.18-1.24-6.16-3.45-8.39ZM12.07 21.3a9.35 9.35 0 0 1-4.76-1.31l-.34-.2-3.67.96.98-3.57-.22-.37a9.35 9.35 0 1 1 8.01 4.49Zm5.39-6.93c-.3-.15-1.75-.86-2.03-.96-.27-.1-.47-.15-.68.15-.2.3-.78.96-.95 1.16-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.47-.89-.8-1.5-1.8-1.68-2.1-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.64-.93-2.25-.24-.57-.49-.5-.68-.5h-.58c-.2 0-.52.08-.8.37-.27.3-1.05 1.02-1.05 2.48 0 1.46 1.08 2.87 1.24 3.07.15.2 2.13 3.25 5.18 4.54.72.31 1.27.5 1.7.64.71.23 1.35.2 1.86.12.57-.09 1.75-.72 2-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z"/>
              </svg>
              <span>+91 88671 98007 / +91 88671 93007</span>
            </a>
            <a
              href="https://share.google/pTMB7aX8YZZOBxWJZ"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: 'inherit', textDecoration: 'none', fontSize: isMobile ? 'clamp(0.8rem, 2vw, 0.9rem)' : '1rem' }}
            >
              <MapPin size={isMobile ? 16 : 18} style={{ flexShrink: 0 }} aria-label="map location" />
              <span>Kuvempunagar, Mysuru - Click for directions</span>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p style={{ fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.85rem)' : '1rem' }}>© 2024 Adhva Academy. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
